import { useMemo, useState } from "react";
import { axiosInstance } from "@services/api/api";
import { Constant } from "@services/constant";
import { MachineProcessDataProps } from "../machine/machine.interface";
import { ProcessControllerProps, ProcessProps } from "./process.interface";
import { removeJobWorkData } from "@services/redux/allCompanyDetails/action";
import { useAppDispatch, useAppSelector } from "@services/redux/controller";

const processController = ({
  userId,
}: ProcessProps): ProcessControllerProps => {
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [index, setIndex] = useState<string>("");
  const [processId, setProcessId] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const { jobWork } = useAppSelector((state) => state.allCompanyDetailsReducer);
  const dispatch = useAppDispatch();
  const processData: MachineProcessDataProps[] = useMemo(
    () =>
      jobWork
        ?.filter((item: any) => item.processes)
        .map((item: any) => ({
          _id: item._id,
          title: item.processes,
          description: item.processesJobDescription,
          file: item.processesFiles,
        }))
        .reverse(),
    [jobWork]
  );

  const handleCloseDrawer = (): void => {
    setOpenDrawer(false);
  };

  const handleOpenDrawer = (id?: string): void => {
    setOpenDrawer(true);
    setIndex(id);
  };

  const removeProcess = async (processId: string) => {
    /* API call for removing process */
    setProcessId(processId);
    const formData = new URLSearchParams();
    formData.append("userId", userId);
    formData.append("type", "1");
    formData.append("jobWorkId", processId);
    try {
      setLoading(true);
      const { data } = await axiosInstance.post(
        Constant.RemoveProductJobworkJobVacancy,
        formData.toString()
      );
      setLoading(false);
      dispatch(removeJobWorkData(data.data));
    } catch (error) {
      setLoading(false);
    }
  };

  return {
    processData,
    handleCloseDrawer,
    openDrawer,
    handleOpenDrawer,
    index,
    removeProcess,
    loading,
    processId,
  };
};

export default processController;
